import * as uiAnalyticsConsumer from '@servicenow/ui-analytics-consumer';
const {createTraceId, getConfigValue} = uiAnalyticsConsumer;

const x = 2147483648;
const baseId =
	Math.floor(Math.random() * x).toString(36) +
	Math.abs(Math.floor(Math.random() * x) ^ Date.now()).toString(36);

let count = 0;

function isTracingEnabled() {
	return getConfigValue('enableTrace') === true;
}

export default function createTransactionId() {
	if (isTracingEnabled()) {
		return createTraceId();
	} else {
		count = count + 1;
		return `${baseId}-${count}`;
	}
}
